import { Link } from "react-router-dom";

const Launch = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <section className="Launch">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="terminal">
                <div className="heading">
                  <h4>Think Local, Act Local, Invest Local </h4>
                  <p>
                    Get a $POCKET token (and a tax break) and put it to work
                    with others in the ecosystem focusing on Community Capital
                    and Sustainable Goals.
                  </p>
                  <Link to=""  onClick={() => scrollToSection("main-comp")} className="apply">
                    <img src="/images/arrow.png" alt="" />
                    Join The Pre Sale
                  </Link>
                </div>
                <div className="image">
                  <img src="/images/terminalrocket.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Launch;
